import styled from 'styled-components'
import { Section } from '../../components/Section'
import { Attribute } from '../../components/Attribute'
import { Separator } from '../../components/Separator'

export const OverlaySection = styled(Section)`
  width: 100%;
  padding-right: 20px;

  position: sticky;
  top: 0;

  background: var(
    --background-color,
    ${({ theme }) => theme.colors.background.secondary.A}
  );

  z-index: 1;

  box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.border.A};

  & + ${Separator} {
    /* Hide the first separator so it doesn't show when rendering  */
    visibility: hidden;
  }
`

export const OverlayAttribute = styled(Attribute)`
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  padding-right: 0;
`
